import { ObserverService } from '@DavisDigital/davisdigitalfrontend.module';

class PaginationController {
	
	public totalPages: number;
	public currentPage: number;
	public onChange;
	
	public delta: number = 2;
	public numberRange: Array<string|number>;
	public ellipsisRange: Array<string|number>;
	
	// @ngInject
	constructor(
		private observerService: ObserverService
	) {}
	
	public $onInit = () => {
		
		if ( 'undefined' === typeof this.totalPages ) {
			console.error( 'Pagination directive: totalPages must be provided' );
			return;
		}
		
		// Parse inputs to numbers, add default currentPage if undefined.
		this.totalPages = +this.totalPages;
		this.currentPage = ( 'undefined' === typeof this.currentPage ) ? 1 : +this.currentPage;
		this.getRange( this.currentPage, this.totalPages );
	}
	
	private getRange = ( currentPage: number, totalPages: number ): any => {
		
		let minNumber = currentPage - this.delta;
		let maxNumber = currentPage + this.delta;
		
		// Create number range.
		let numberRange = [1];
		for ( let i = currentPage - this.delta; i <= currentPage + this.delta; i++ ) {
			if ( i >= minNumber && i <= maxNumber && i < totalPages && i > 1 ) {
				numberRange.push( i );
			}
		}
		numberRange.push( totalPages );
		
		// Create ellipsis range using our number range.
		let prevNumber;
		let ellipsisRange = [];
		for ( let currentNumber of numberRange ) {
			if ( prevNumber ) {
				
				/**
				 * Check if the previous and current number are more than 1 away from eachother.
				 * If it's the difference is 2, just push the number inbetween
				 * If the difference is > 2, add an ellipsis
				 **/
				 
				if ( 2 === currentNumber - prevNumber ) {
					ellipsisRange.push({
						label: prevNumber + 1,
						value: prevNumber + 1 
					});
				} else if ( 2 < currentNumber - prevNumber ) {
					if ( this.currentPage > currentNumber ) {
						ellipsisRange.push({
							label: '...',
							value: this.currentPage - ( this.delta * 2 )
						});
					} else {
						ellipsisRange.push({
							label: '...',
							value: this.currentPage + ( this.delta * 2 )
						});
					}
				}
			}
			
			// Push the current number and set the prev for the next loop.
			ellipsisRange.push({
				label: currentNumber,
				value: currentNumber,
			});
			prevNumber = currentNumber;
		}
		
		this.ellipsisRange = ellipsisRange;
		this.numberRange = numberRange;
		
		return this;
	}
	
	public setPage = ( pageNumber: number ): any => {
		this.currentPage = pageNumber;
		this.getRange( pageNumber, this.totalPages );
		
		if ( 'function' === typeof this.onChange ) {
			this.onChange( pageNumber );
		}
		
		return this;
	}
}

class Pagination {
	
	public restrict: string = 'EA';
	public scope: any;

	public bindToController: any = {
		currentPage: '=',
		totalPages: '=',
		onChange: '='
	};

	public controller = PaginationController;
	public controllerAs = 'pagination';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/pagination.html';

	public static Factory() {
		return () => new this();
	}
}

export { Pagination };
